import { Component, OnInit, ElementRef, HostListener, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, ValidationService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
//import { EnrollmentToolModal, MdmDetails } from '../../enrollment-tool/enrollment-tool.modal';
import { InitialService } from '../../initial-signup/initial-signup.service';
import { CancelParticipationService } from './../shared/providers/cancel-participation.service';
import { MdmDetails } from '../shared/models/cancel-participation.model';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { FormBuilderService } from 'lib/ng2-sapmp/src/ui-components/form-builder/form-builder.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
import { DonutChartModel } from 'lib/ng2-sapmp/src/ui-components/charts/donut-chart';
import { CHART_CONFIG, ERRCODES } from 'config';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

declare var logoutCurrentUser: any;

@Component({
  selector: 'app-remove-account',
  templateUrl: './remove-account.component.html',
  styleUrls: ['./remove-account.component.scss'],
  providers: [ValidationService, CancelParticipationService, FormBuilderService, InitialService],
  encapsulation: ViewEncapsulation.None
})

export class RemoveAccountComponent implements OnInit {
    removeModel: any;
    appleModel: any;
    toolSelection: string;
    totalNoFans: any;
    selectionTool: FormGroup;
    userDetail: any;
    selectedDetails: any;
    otherProductsSelection: any;
    childemmAccountId: any;
    parentemmAccountId: any;
    selectedDetailsKme: any;
    selectedDetailsAbm: any;
    signupEmmStatus: any;
    selectedValuesSession: any;
    selectedAccID: any;
    enrollemntType: any;
    enableSetupType = false;
    sessionData: any;
    chartLabel: string;
    donutChartData: Array<DonutChartModel>;
    chartRadius = 90;
    strokeWidth = 20;
    startIndex = 0;
    errorMessage: any;
    pageError: boolean;
    showError: boolean;
    chartError: boolean;
    pivots: Array<MobilePivotModel>;
    totalFansNum: any;

    setupError = false;
    selected = true;
    googleValue: any;
    samsungValue: any;
    isSamsungDisable = false;
    isGoogleDisable = false;
    showGoogleCreationError = false;
    mdmDetails: MdmDetails;
    selectedMdmDetails: any;
    selectMdm: FormGroup;
    preSelectedMdmDetail: any;
    tcUrl: any;
    manageProduct: any;
    preSelectedEmm: any;
    preSelectedMdmselect: any;
    fanProductData: any;
    productSelectionStatus: any;
    productSignupStatus: any;
    callSamsung: boolean = true;
    private fanList: any;
    private readyToSetupFansCount;
    awaitingSignupFansCount: any;
    private activeFansCount;
    private processingFansCount;
    private activeFans: any;
    private processingFans: any;
    ineligibleFansCount: any = 0;
    pageLoadChangesDone: boolean = false;
    samsungFanCount: number = 0;
    googleFanCount: number = 0;
    initialized: boolean = false;
    unclaim: boolean = false;
    kmelistcount: number = 0;
    ztplistcount: number = 0;
    abmlistcount: number = 0;
    optselected: boolean = false;
    public showView = false;
    private activeDeployedFans: any;
    private totalFans: any;
    oemStatus = false;
    accountDetails: any;
    userModel: UserProfileModel;
    private totalRecords = 0;
    private paginationArray: Array<any>;
    selectedProgram:any;
    flag = false;

    
    formErrors = {
        'googleIdName': '',
        'samsungIdName': '',
        'appleIdName': ''
    };

    validationMessages = {
        'googleIdName': {
            'required': 'Google ID is required.',
            'pattern': 'Enter a valid email address. This should be the email you use to log in to Google®.'
        },
        'samsungIdName': {
            'required': 'Samsung ID is required.',
            'pattern': 'Please enter a valid Samsung ID.'
        },
        'appleIdName': {
            'required': 'Apple ID is required.',
            'pattern': 'Please enter a valid Apple ID.'
        }
    };


    constructor(private utilityService: UtilityService, private router: Router,
        private CancelParticipationService: CancelParticipationService, private breadCrumbService: BreadCrumbService, private el: ElementRef,
        private formBuilder: FormBuilder, private validationService: ValidationService, private authenticationService: AuthenticationService,
        private pageloaderService: PageLoaderService, private adobeAnalyticsService: AdobeAnalyticsService,
        private route: ActivatedRoute, private InitialService: InitialService) {
            this.mdmDetails = new MdmDetails();
            this.userModel = new UserProfileModel();
            this.childemmAccountId = [];
    }



    ngOnInit() {
        sessionStorage.removeItem('CancelParticipationData');
        sessionStorage.removeItem('UnclaimDevicesData');
        sessionStorage.removeItem('ReviewedData');
        sessionStorage.removeItem('selectedFanList');
        this.selectedProgram = sessionStorage.getItem("emmProductCode");
        let removeManage = sessionStorage.getItem("removeManage");
        if( removeManage === 'true' ){
            // this.toolSelection = this.selectedProgram; 
            // this.optselected = true;
        } else if( this.selectedProgram){
            this.flag =true;
            this.toolSelection = this.selectedProgram; 
            this.optselected = true;
            if(this.selectedProgram == "DMPAABM"){
                this.CancelParticipationService.setProdCode('ABM');
            }else if(this.selectedProgram == "DMPSKME"){
                this.CancelParticipationService.setProdCode('KME');
            }else{
                this.CancelParticipationService.setProdCode('ZTP');
            }
            
        }

        document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
        this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
        //this.breadCrumbService.setCurrentBreadCrumb({ label: 'Remove Account', routerLink: '/cancelParticipation/removeaccount' });
        this.removeModel = this.route.snapshot.data.pageData.cancelParticipationremoveaccount;
        sessionStorage.setItem('unclaimFlag', 'true');
        this.donutChartData = [];
        this.initChart();
        this.buildForm();
        this.toolSelectionDetails();
    }

    initChart() {   
        this.pageloaderService.setPageLoaderStatus(false);
        this.CancelParticipationService.getFANList1()
        .subscribe((resp) => {
            this.pageloaderService.setPageLoaderStatus(true);
            this.fanList = resp;
            this.chartError = false;
            this.plotFanStatusChart(this.fanList);
            //this.toolSelectionDetails();
        }, (err) => {
            this.handleError('FETCH_FANSUMMARY');
            this.chartError = true;
            this.buildErrorChartData();
            //this.toolSelectionDetails();
        });
            
    }

    buildForm(): void {
        this.selectionTool = this.formBuilder.group({
            'googleIdName': ['', [Validators.required,
                Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
            'samsungIdName': ['', [Validators.required, Validators.pattern(/(^[0-9]{1,100}$)+$/)]],
            'appleIdName':['', [Validators.required, Validators.pattern(/(^[0-9]{1,32}$)+$/)]],
            'toolSelection': []
        });
        this.validationService.validate(
            this.selectionTool,
            this.formErrors,
            this.validationMessages
        );
    }

    toolSelectionDetails() { 
      this.sessionData = JSON.parse(sessionStorage.getItem('mdmDetails'));
      if (this.sessionData && this.sessionData.productCode === 'ADDPZTE') {
            if (this.sessionData.samsungEmmAccountId && this.sessionData.googleEmmAccountId && this.sessionData.appleEmmAccountId) {
                this.callSamsung = false;
                if (this.sessionData.latestAccountType === 'DMPGZTP') {
                      this.mdmDetails.emmProductCode = 'DMPGZTP';
                      this.mdmDetails.signupStatus = 'revised';
                      this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
                      this.mdmDetails.otherProducts[0] = {'emmProductCode' : 'DMPSKME', 'signupStatus' : 'revised' , 'emmAccountId' :  this.sessionData.samsungEmmAccountId};
                      this.mdmDetails.otherProducts[1] = {'emmProductCode' : 'DMPAABM', 'signupStatus' : 'revised' , 'emmAccountId' :  this.sessionData.appleEmmAccountId};
                  } else if (this.sessionData.latestAccountType === 'DMPSKME'){
                  // Samsung  - User 5
                      this.mdmDetails.emmProductCode = 'DMPSKME';
                      this.mdmDetails.signupStatus = 'revised';
                      this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
                      this.mdmDetails.otherProducts[0] = {'emmProductCode' : 'DMPGZTP', 'signupStatus' : 'revised' , 'emmAccountId' : this.sessionData.googleEmmAccountId};
                      this.mdmDetails.otherProducts[1] = {'emmProductCode' : 'DMPAABM', 'signupStatus' : 'revised' , 'emmAccountId' :  this.sessionData.appleEmmAccountId};
                  } else {
                    this.mdmDetails.emmProductCode = 'DMPAABM';
                    this.mdmDetails.signupStatus = 'revised';
                    this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
                    this.mdmDetails.otherProducts[0] = {'emmProductCode' : 'DMPGZTP', 'signupStatus' : 'revised' , 'emmAccountId' : this.sessionData.googleEmmAccountId};
                    this.mdmDetails.otherProducts[1] = {'emmProductCode' : 'DMPSKME', 'signupStatus' : 'revised' , 'emmAccountId' :  this.sessionData.samsungEmmAccountId};
                  }

            }else if (this.sessionData.samsungEmmAccountId) {
                  // Samsung  - User 6
                  this.callSamsung = false;
                  this.mdmDetails.emmProductCode = 'DMPSKME';
                  this.mdmDetails.signupStatus = 'revised';
                  this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
                  this.mdmDetails.otherProducts[0] = {'emmProductCode' : 'DMPGZTP' , 'signupStatus' : 'initial' , 'emmAccountId' : ''};
                  this.mdmDetails.otherProducts[1] = {'emmProductCode' : 'DMPAABM', 'signupStatus' : 'initial' , 'emmAccountId' :  ''};
            }else if (this.sessionData.googleEmmAccountId) {
                  // Google - User 4
                  this.mdmDetails.emmProductCode = 'DMPGZTP';
                  this.mdmDetails.signupStatus = 'revised';
                  this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
                  this.mdmDetails.otherProducts[0] = {'emmProductCode' : 'DMPSKME' , 'signupStatus' : 'initial' , 'emmAccountId' : ''};
                  this.mdmDetails.otherProducts[1] = {'emmProductCode' : 'DMPAABM', 'signupStatus' : 'initial' , 'emmAccountId' :  ''};
            } else {
                  this.mdmDetails.emmProductCode = 'DMPAABM';
                  this.mdmDetails.signupStatus = 'revised';
                  this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
                  this.mdmDetails.otherProducts[0] = {'emmProductCode' : 'DMPSKME' , 'signupStatus' : 'initial' , 'emmAccountId' : ''};
                  this.mdmDetails.otherProducts[1] = {'emmProductCode' : 'DMPGZTP', 'signupStatus' : 'initial' , 'emmAccountId' :  ''};
            }
        }
             // To show available to add section on page load
             // Add logic here to select 'available to add' or 'ready to setup' section


            this.userDetail = this.mdmDetails;
            if (this.userDetail) {
                this.preSelectedMdmselect = this.userDetail.emmProductCode;
                this.productSelectionStatus = this.userDetail.signupStatus;
                this.preSelectedMdmDetail = this.preSelectedMdmselect;
                this.productSignupStatus = this.productSelectionStatus;
                this.parentemmAccountId = this.userDetail.emmAccountId;
                this.checkPermission('google');
                this.checkPermission('samsung');
                this.checkPermission('apple');

                if (this.userDetail.otherProducts.length === 0) {
                  this.otherProductsSelection = '';
                  this.childemmAccountId[0] = [];
                  this.childemmAccountId[1] = [];
                } else {
                  this.otherProductsSelection = this.userDetail.otherProducts[0].signupStatus;
                  this.childemmAccountId[0] = this.userDetail.otherProducts[0].emmAccountId;
                  this.childemmAccountId[1] = this.userDetail.otherProducts[1].emmAccountId;
                }
                if (this.userDetail.emmProductCode === 'DMPGZTP' && this.userDetail.signupStatus === 'revised') {
                    //this.toolSelection = 'DMPGZTP';
                    this.parentemmAccountId = this.userDetail.emmAccountId;
                    this.selectedDetails = this.parentemmAccountId;
                    this.signupEmmStatus = 'revised';
                    if (this.parentemmAccountId !== null) {
                        this.setupError = false;
                    }
                    if (this.otherProductsSelection === 'revised') {
                        this.selectedDetailsKme = this.childemmAccountId[0];
                        this.selectedDetailsAbm = this.childemmAccountId[1];
                    }

                } else if (this.userDetail.emmProductCode === 'DMPSKME' && this.userDetail.signupStatus === 'revised') {
                    //this.toolSelection = 'DMPSKME';
                    this.parentemmAccountId = this.userDetail.emmAccountId;
                    this.selectedDetailsKme = this.parentemmAccountId;
                    this.signupEmmStatus = 'revised';
                    if (this.parentemmAccountId !== null) {
                        this.setupError = false;
                    }
                    if (this.otherProductsSelection === 'revised') {
                    this.selectedDetails = this.childemmAccountId[0];
                    this.selectedDetailsAbm = this.childemmAccountId[1];
                    }
                } else if (this.userDetail.emmProductCode === 'DMPAABM' && this.userDetail.signupStatus === 'revised') {
                    
                    this.parentemmAccountId = this.userDetail.emmAccountId;
                    this.selectedDetailsAbm = this.parentemmAccountId;
                    this.signupEmmStatus = 'revised';
                    if (this.parentemmAccountId !== null) {
                        this.setupError = false;
                    }
                    if (this.otherProductsSelection === 'revised') {
                    this.selectedDetailsKme = this.childemmAccountId[0];
                    this.selectedDetails = this.childemmAccountId[1];
                    }
                }
                // Show the details for the product selected.
                this.initialized = true;
                // this.availableToAdd();

            }

    }

    checkPermission(field) { 
        const permission = JSON.parse(sessionStorage.getItem('permissions'));
        if (permission !== 'null') {
          if (!this.utilityService.checkComponentPermission(field, permission.perm)) {
            if (field === 'samsung') {
              this.el.nativeElement.getElementsByClassName('sIdPerm')[0].setAttribute('disabled', 'true');
              this.isSamsungDisable = true;
            } else {
              this.el.nativeElement.getElementsByClassName('gIdPerm')[0].setAttribute('disabled', 'true');
              this.isGoogleDisable = true;
            }
          }
        }
    }

    handleError(type) {
        this.pageloaderService.setPageLoaderStatus(true);
        this.errorMessage = ERRCODES[type];
        if (type === 'FETCH_PAGE') {
            this.pageError = true;
        } else {
            this.showError = true;
        }
    }

    plotFanStatusChart(data) { 
        //const dataArray: Array<DonutChartModel> = [];

        this.activeFans = data.revisedFanList.filter((f) => { return f.accountStatus === 'ACTIVE'; });
        let processingFans_ = data.revisedFanList.filter((f) => {return f.accountStatus === 'PROCESSING' && f.productCode != 'DMPAABM'});
        this.activeFans = this.activeFans.concat(processingFans_);
        console.log("this.activeFans==>", this.activeFans);
        const activeFansList = this.activeFans.map(item => ({ fanId: item.fanId, productCode: item.productCode }));
        const mergedList = activeFansList.concat(data.newSetupFanList);
        let uniqueList = mergedList.filter((element, index) => {
            return mergedList.indexOf(element) === index;
        });
        let uniqueListCount = uniqueList ? uniqueList.length : 0;
        for(var i=0;i<uniqueListCount;i++) {
            const kmelist: Array<DonutChartModel> = [];
            const ztplist: Array<DonutChartModel> = [];
            const abmlist: Array<DonutChartModel> = [];
            if(uniqueList[i].productCode === 'DMPSKME') {
                this.kmelistcount++;
            }
            else if(uniqueList[i].productCode === 'DMPGZTP') {
                this.ztplistcount++;
            }
            else if (uniqueList[i].productCode === 'DMPAABM'){
                this.abmlistcount++;
            }
        }

        //mock Data
        // this.kmelistcount = 3;
        // this.ztplistcount = 6;
        // this.abmlistcount = 9;

        this.totalFansNum = this.kmelistcount + this.ztplistcount + this.abmlistcount;
        this.buildChartArray(CHART_CONFIG.KME, this.donutChartData, this.kmelistcount);
        this.buildChartArray(CHART_CONFIG.ZTP, this.donutChartData, this.ztplistcount);
        this.buildChartArray(CHART_CONFIG.ABM, this.donutChartData, this.abmlistcount);

        //this.donutChartData = dataArray;
        this.totalNoFans = `You have ${this.kmelistcount + this.ztplistcount + this.abmlistcount} foundation accounts that are signed up and are ready to be managed with the device management program.`
        this.chartLabel = 'accounts';
        if(this.totalFansNum < 2){
            this.totalNoFans = this.totalNoFans.replace('accounts', 'account');
            this.totalNoFans = this.totalNoFans.replace('are signed up and are', 'is signed up and is');
            this.chartLabel = 'account';
        }
        const addpDashboardContainer = this.el.nativeElement.getElementsByClassName('chart-legend-container');
        switch (this.donutChartData.length) {
          case 1 : {
            addpDashboardContainer[0].style.paddingTop="95px";
            break;
          }
          case 2 : {
            addpDashboardContainer[0].style.paddingTop="80px";
            break;
          }
          case 3 : {
            addpDashboardContainer[0].style.paddingTop="65px";
            break;
          }
          case 4 : {
            addpDashboardContainer[0].style.paddingTop="55px";
            break;
          }
        } 
    }

    buildChartArray(chartConfig, dataArray, noOfFans) {
        if (noOfFans > 0) {
            const temp: DonutChartModel = {
                'value': noOfFans,
                'color': chartConfig.color,
                'legend': noOfFans + ' ' + chartConfig.label
            };
            dataArray.push(temp);
        }
    }

    buildErrorChartData() {
        this.donutChartData = [];
        this.chartLabel = 'accounts';
        const temp = {
            'value': 0,
            'color': '#ccc',
            'legend': 'Error'
        };
        this.donutChartData.push(temp);
    }

    toolSelectedztp($event) {
        if ($event.target.value = 'on') {
            this.CancelParticipationService.setProdCode('ZTP');
            this.toolSelection = 'DMPGZTP';
            this.optselected = true;
        }
        
    }

    toolSelectedabm($event) {
        if ($event.target.value = 'on') {
            this.CancelParticipationService.setProdCode('ABM');
            this.toolSelection = 'DMPAABM';
            this.optselected = true;
        }
        
    }

    toolSelectedkme($event) {
        if ($event.target.value = 'on') {
            this.CancelParticipationService.setProdCode('KME');
            this.toolSelection = 'DMPSKME';
            this.optselected = true;
        }
    }

    cancel() {
        this.router.navigate(['/dashboard']);
    }

    continue() {
        this.pageloaderService.setPageLoaderStatus(false);
        this.removeModel.appleIdName = this.selectedDetailsAbm;
        this.removeModel.googleIdName = this.selectedDetails;
        this.removeModel.samsungIdName = this.selectedDetailsKme;
        if (this.toolSelection === 'DMPGZTP'||  this.toolSelection === 'DMPSKME' || this.toolSelection ==='DMPAABM' ) { 
            if (this.toolSelection === 'DMPGZTP') {
                this.selectedAccID = this.removeModel.googleIdName;
            } 
            else if (this.toolSelection === 'DMPSKME') {
                this.selectedAccID = this.removeModel.samsungIdName;
            }else{
                this.selectedAccID = this.removeModel.appleIdName;
            }
            let productDetails = { emmProductCode: '', emmAccountId: ''};
            this.selectedMdmDetails = this.toolSelection;
            productDetails.emmProductCode = this.toolSelection;
            productDetails.emmAccountId = this.selectedAccID;
            sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
            sessionStorage.getItem('manage-product'); 
            this.router.navigate(['cancelParticipation/selectfan']);
        }
    }

}